import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Col } from 'antd';
import { Link } from 'react-router-dom';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';
import ProfileMain from './components/ProfilePreview';
import ProfileTabs from './components/ProfileTabs';

const mapStateToProps = state => ({ views_permissions: state.App.Permissions.views_permissions });
const BreadcrumbItem = Breadcrumb.Item; const
    breadcrumb_position = { margin: '0 0 1% 4%' };

export default connect(mapStateToProps, null)(checkPermissionsHOC(class User_profile extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const user_profile_access = views_permissions['view://UserManagement/User_profile'];

        if (!user_profile_access) {
            return <NotFound />;
        }

        return (
            <div className="profile user-profile-container">
                <Breadcrumb style={breadcrumb_position}>
                    <BreadcrumbItem><Link to="/UserManagement/User_list">Users List</Link></BreadcrumbItem>
                    <BreadcrumbItem>User Profile</BreadcrumbItem>
                </Breadcrumb>
                <Col span={7} offset={1}>
                    <ProfileMain id={this.props.location.pathname.slice(-24)} />
                </Col>
                <Col span={14}>
                    <ProfileTabs id={this.props.location.pathname.slice(-24)} />
                </Col>
            </div>
        );
    }
}, ['view://UserManagement/User_profile']));



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/index.js